const { HomePageHandler } = require('../handlers/Flight/HomePageHandler'),
    { SearchPageHandler } = require('../handlers/Flight/SearchPageHandler'),
    { ItinearyPageHandler } = require('../handlers/Flight/ItinearyPageHandler'),
    { PassengerDetailPageHandler } = require('../handlers/Flight/PassengerDetailPageHandler'),
    { PassengerReviewPageHandler } = require('../handlers/Flight/PassengerReviewPageHandler'),
    { PaymentPageHandler } = require('../handlers/Flight/PaymentPageHandler'),
    { ConfirmationPageHandler } = require('../handlers/Flight/ConfirmationPageHandler');

const flightMapping = {
    Home: HomePageHandler,
    Srp: SearchPageHandler,
    Itinerary: ItinearyPageHandler,
    PassengerDetail: PassengerDetailPageHandler,
    PassengerReview: PassengerReviewPageHandler,
    Payment: PaymentPageHandler,
    Confirmation: ConfirmationPageHandler
}

module.exports = { flightMapping }